import { AgGridReact } from 'ag-grid-react'
import React from 'react'

import { useAlert } from 'react-alert'
import { Error, Header, Loader } from '../components'

import { useGetSuggestionsQuery } from '../redux/suggestions/suggestionsApi'
import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-alpine.css'
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css'
import { useStateContext } from '../contexts/ContextProvider'


//icons 
import { CgDetailsMore } from 'react-icons/cg'
import SuggestionModal from '../components/SuggestionModal'


const CellRenderer = p => {

    return <div className='flex flex-row justify-end'>
        <div>
            <CgDetailsMore title='Show More' className=' mt-1 text-red-600 hover:cursor-pointer' onClick={() => {

                //opening the modal
                p.openModal(true)
                p.setModalRow(p.data)
            }} />
        </div>
    </div>
}


const Suggestions = () => {
    const { data, isLoading, error } = useGetSuggestionsQuery()
    const { currentMode } = useStateContext()
    const [showModal, setShowModal] = React.useState(false);

    const [modalRow, setModalRow] = React.useState(null)

    const alert = useAlert()

    const defaultColDefs = {
        sortable: true, filter: true,
    }

    const columnsDefs = [
        { field: "title", flex: 2, },
        { field: 'user.name', headerName: "User", flex: 2 },
        { field: 'user.address.house', headerName: "🏠", flex: 2 },
        { field: 'user.address.street', headerName: "Street", flex: 2 },
        { field: 'user.address.block', headerName: "Block", flex: 2 },
        { field: "description", flex: 4 },
        {
            field: '_id', headerName: "Details", cellRenderer: CellRenderer, flex: 2,
            cellRendererParams: {
                openModal: setShowModal,
                setModalRow: setModalRow
            }
        }

    ]


    if (isLoading) return <Loader />

    if (error) {
        alert.error(error.data.message)
        alert.removeAll()
        return <Error />
    }



    return (
        <div className={`m-2 md:m-10 p-2 md:p-10 bg-white rounded-3xl ${currentMode === 'Dark' ? 'ag-theme-alpine-dark' : 'ag-theme-alpine'} h-[500px]`}>
            <Header title="Residents Suggestions 💡💡" category="Page" />

            <div className='h-[70%] w-[100%] ' style={{

            }}>

                <AgGridReact rowData={data.suggestions} columnDefs={columnsDefs} defaultColDef={defaultColDefs} animateRows={true} />
            </div>
            <SuggestionModal showModal={showModal} setShowModal={setShowModal}  modalRow={modalRow}/>
        </div>

    )
}

export default Suggestions